import { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import ReactPlayer from 'react-player';
import punteroImgPlay from '../img/puntero/PlayReel.png';
import punteroImgStop from '../img/puntero/CloseReel.png';
import useMediaQuery from '../hooks/MediaQueryhook';
import { useDispatch, useSelector } from 'react-redux';
import { FullScreen, Normal } from '../redux/PlayReelSlice';
import { InPageHome } from '../redux/InPage';
import Spy from '../Spy.js';

const VideoContainer = styled.div`
  filter: brightness(1);
  //background-color: green;
  opacity: 1;
  overflow: hidden;
  cursor: none;
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 2;
  z-index: 1;
  scale: 1;
  ${({ screen }) =>
    screen === 'FullScreen' &&
    css`
      padding-left: 0%;
    `}
  @media screen and (min-width: 0px) and (max-width: 768px) {
  }

  @media (min-width: 769px) and (max-width: 820px) {
    scale: 1.2;
  }
`;

const VideoWrapper = styled.div`
  padding-bottom: 49.63%;
  overflow: hidden;
  width: 100%;
`;

const VideoMascara = styled.div`
  opacity: 0.5;
  //background-color: blue;
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 2;
  width: 100%;
  height: 100%;
  overflow: hidden;
  //padding-left: 20%;
  cursor: none;
  z-index: 2;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

/*la idea es hacer de cuenta que todos los otros componentes 
padres se ajustan a este componente FuncVideo hasta cierto punto y luego funcVideo se ajusta a los otros. 
es como si el menu rojo funciona como si estuviera adentro del video hasta cierto punto*/

/*luego para el manejo del boton se heredan las propiedades de padre a hijo hasta llegar a este componente*/

const FuncVideo = ({ playing, url }) => {
  const [muted, setMuted] = useState(true);

  let screen = useSelector((state) => state.screen.value);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(InPageHome());
  }, [dispatch]);

  const isMediaQueryMayor769px = useMediaQuery('(min-width: 769px)');

  const playerRef = useRef(null);

  const pauseVideo = () => {
    const internalPlayer = playerRef.current?.getInternalPlayer();
    if (internalPlayer && videoLoaded) {
      internalPlayer.pause();
    }
  };

  const playVideo = () => {
    const internalPlayer = playerRef.current?.getInternalPlayer();
    if (internalPlayer && videoLoaded) {
      internalPlayer.play();
    }
  };

  const restartVideo = () => {
    const internalPlayer = playerRef.current?.getInternalPlayer();
    if (internalPlayer && videoLoaded) {
      playerRef.current.seekTo(0);
      internalPlayer.play();
    }
  };

  let current = window.location.pathname;
  const onClick = () => {
    if (isMediaQueryMayor769px) {
      screen === 'FullScreen'
        ? dispatch(Normal()) & setMuted(true)
        : setMuted(false) & dispatch(FullScreen()) & restartVideo();
    }
    playVideo();
    Spy('Events', 'PlayReelHome');
  };

  //------------------- IntersectionObserver API javasacript parecido al focus pero no necesitamos hacer click ---------------

  const videoRef = useRef(null); // Creamos una referencia a nuestro elemento de video.
  const [isVideoInView, setIsVideoInView] = useState(true); // Estado para saber si el video está visible o no.

  useEffect(() => {
    const videoElement = videoRef.current; // Obtenemos el elemento de video mediante la referencia.

    const observerOptions = {
      root: null, // Observamos el área visible del viewport.
      rootMargin: '0px', // Margen alrededor del área visible (en este caso, ninguno).
      threshold: 0.5, // Define el umbral para considerar que el video está visible (50% en este caso).
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Si el video está dentro del área visible (50% o más), establecemos el estado a true.
          setIsVideoInView(true);
          playVideo();
          setMuted(true);
        } else {
          // Si el video ya no está en el área visible, establecemos el estado a false.
          setIsVideoInView(false);
          pauseVideo();
          setMuted(true);
          dispatch(Normal());
        }
      });
    };

    const observer = new IntersectionObserver(
      observerCallback,
      observerOptions
    ); // Creamos el IntersectionObserver.

    if (videoElement) {
      observer.observe(videoElement); // Observamos el elemento de video con el IntersectionObserver.
    }

    return () => {
      if (videoElement) {
        observer.unobserve(videoElement); // Dejamos de observar el elemento cuando el componente se desmonta.
      }
    };
  }, []); // El array vacío indica que este efecto se ejecutará solo una vez, al montar el componente.

  //--------------------------------------------------------------------------------------------------------------------------

  const [videoLoaded, setVideoLoaded] = useState(false);

  useEffect(() => {
    if (!playing) {
      restartVideo();
      setMuted(false);
    } else {
      setMuted(true);
    }
  }, [playing, videoLoaded]);

  const handleMobileTap = async () => {
    const player = playerRef.current?.getInternalPlayer();
    if (!player) return;
    try {
      await player.requestFullscreen();
      await player.setMuted(false);
    } catch (e) {}
  };

  const handlePlayerReady = () => {
    setVideoLoaded(true);
    if (!isMediaQueryMayor769px) {
      const player = playerRef.current?.getInternalPlayer();
      player?.on('fullscreenchange', ({ fullscreen }) => {
        if (!fullscreen) setMuted(true);
      });
    }
  };

  return (
    <>
      <VideoMascara
        style={{
          cursor: isMediaQueryMayor769px
            ? screen == 'Normal'
              ? `url(${punteroImgPlay}), pointer`
              : `url(${punteroImgStop}), pointer`
            : 'pointer',
        }}
        onClick={() => isMediaQueryMayor769px ? onClick() : handleMobileTap()}
      />
      <VideoContainer screen={screen} ref={videoRef}>
        <VideoWrapper>
          <ReactPlayer
            style={{
              position: 'absolute',
              top: '0',
              left: '0',
            }}
            width="100%"
            height="100%"
            ref={playerRef}
            url={url}
            controls={false}
            playing={true}
            config={{
              vimeo: {
                quality: 'auto',
              },
            }}
            loop
            muted={muted}
            onReady={handlePlayerReady}
          />
        </VideoWrapper>
      </VideoContainer>
    </>
  );
};

export { FuncVideo };
